import React from 'react';
import * as Styled from './styled';
import { useImageUrlBuilder } from 'hooks/useImageUrlBuilder';
import { noop } from 'lodash';

interface ImageItemProps {
  url: string;
  height: number;
  rotateDegrees: number;
  altText?: string;
  style?: React.CSSProperties;
  handleClick?: () => void;
}

export const ImageItem: React.FC<ImageItemProps> = ({
  url,
  rotateDegrees,
  altText,
  height,
  style,
  handleClick = noop,
}) => {
  const constructImageURI = useImageUrlBuilder();

  const uri = constructImageURI(url, {
    height,
    rotateDegrees,
  });

  return (
    <Styled.ImageRoot onClick={handleClick} style={style}>
      <Styled.Image
        alt={altText || undefined}
        data-auto="bulletin-image"
        data-auto-url={uri}
        src={uri}
      />
    </Styled.ImageRoot>
  );
};
